// extracted by mini-css-extract-plugin
module.exports = {"list":"factList-module--list--3G_8B","itemContainer":"factList-module--itemContainer--2l7_G","item":"factList-module--item--2uRV8"};